import { isPlatformBrowser } from '@angular/common';
import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Inject,
  PLATFORM_ID,
  AfterViewInit,
} from '@angular/core';

@Directive({
  selector: '[appRatio]',
  standalone: true,
})
export class RatioDirective implements AfterViewInit {
  @Input() x: number;
  @Input() y: number;

  private element: HTMLElement;
  initialWidth: number;
  ratio: number;
  private isBrowser = false;

  constructor(@Inject(PLATFORM_ID) platformId: Object, private elementRef: ElementRef) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngAfterViewInit(): void {
    if (!this.isBrowser || !this.x || !this.y) {
      return;
    }

    this.element = this.elementRef.nativeElement as HTMLElement;
    this.initialWidth = this.element.clientWidth;
    this.ratio = this.x / this.y;
    this.setHeight();
  }

  @HostListener('window:resize')
  setHeight(): void {
    if (!this.element) {
      return;
    }
    const currentWidth = this.element.clientWidth;
    const newHeight = (currentWidth / 16) * 9;

    this.element.style.setProperty('height', newHeight + 'px');
  }
}
